import DemographicsForm from "./components/DemographicsForm";

function App() {
  return <DemographicsForm />;
}

export default App;